// Firebase Configuration for Taraanaya
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  RecaptchaVerifier, 
  signInWithPhoneNumber,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signInWithCredential,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged
} from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAxu7nCznOapO7PDe3eXmIV1eZa-J6StbQ",
  authDomain: "taraanaya-96f2b.firebaseapp.com",
  projectId: "taraanaya-96f2b",
  storageBucket: "taraanaya-96f2b.firebasestorage.app",
  messagingSenderId: "621703688018",
  appId: "1:621703688018:web:8ebfc6fd2d5daa4c44948b",
  measurementId: "G-668JM1F19K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Google Provider
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Enable phone auth persistence
auth.useDeviceLanguage();

// Export all auth methods
export { 
  auth, 
  RecaptchaVerifier, 
  signInWithPhoneNumber,
  googleProvider,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  signInWithCredential,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged
};

export default app;
